import { ThemeInput } from "./tokens";

export default {
  dark: false,
  colors: {
    "primary": "#132356",
    "on-primary": "#ffffff",
    "secondary": "#132356",
    "on-secondary": "#ffffff",
    "tertiary": "#ffcc00",
    "on-tertiary": "#000000",
    "error": "#FF5252",
    "on-error": "#ffffff",
    "background": "#eeeeee",
    "on-background": "#000000",
    "surface": "#F8F8F8",
    "on-surface": "#494949",
    "dark-background": "#132356",
    "on-dark-background": "#ffffff",
    "content-background": "#F8F8F8",
    "on-content-background": "#000000",
    "heading": "#ffffff",
    "body": "#D4D4D4",
    "info": "#2196F3",
    "on-info": "#ffffff",
    "success": "#4CAF50",
    "on-success": "#ffffff",
    "warning": "#FB8C00",
    "on-warning": "#ffffff",
    "stripes-background": "#2d4089",
    "on-stripes-background": "#ffffff",
  },
  variables: {},
} satisfies ThemeInput;
